import AxiosApiInstance, {APIBase} from "../../../../AxiosApiInstance";
import {AxiosResponse} from "axios";

const ApiBackCampaignsConfigsNotificationsIdDelete
  = (id: string, campaign_pk: string)
  :Promise<AxiosResponse> => {
    return AxiosApiInstance.delete(`${APIBase}back/campaigns/${campaign_pk}/configs/notifications/${id}/`);
  };

export default ApiBackCampaignsConfigsNotificationsIdDelete;